import objectHash from 'object-hash';
import { useContext, useEffect } from 'react';

import { SliderProducts } from '@/components/Cms/SliderProducts';
import { useFetchProductsWithCta } from '@/hooks/useFetchProductsWithCta';
import { generateDataTestId } from '@/lib/tests';
import { DraftModeContext } from '@/providers/DraftModeProvider/DraftModeContext';

import { CMSSection } from '../CMSSection';
import type { AutomaticCarouselProps } from './AutomaticCarousel';

export const AutomaticCarouselDefault = ({
  excludeSlug,
  filter,
  ...props
}: AutomaticCarouselProps) => {
  const draftMode = useContext(DraftModeContext);
  const { products, refetch } = useFetchProductsWithCta({
    filter,
    excludeSlug: excludeSlug,
    orderedSlugs: filter?.slugs ?? [],
    skip: true,
  });

  const filterHash = objectHash(filter || {});

  useEffect(() => {
    refetch();
  }, [filterHash, excludeSlug]);

  if (!products.length) {
    return null;
  }
  // Wrapper here, not in AutomaticCarousel: above the null check it left an
  // empty margin-carrying <section> on screen during the fetch.
  return (
    <CMSSection {...generateDataTestId('carouselAutomatic', 'section')}>
      <SliderProducts
        data-test-id='AutomaticCarouselSliderProducts'
        {...props}
        draftMode={draftMode}
        isAutomaticSlider={true}
        orderedSlugs={filter?.slugs ?? []}
        productData={products}
      />
    </CMSSection>
  );
};
